// @ts-check
import { Box, Button, StarIcon, Text } from '~/design-system';
import { Trans } from '@lingui/macro';
import { useCommonLinks } from '../pages/imports/_config';
import Layout from './Layout/Layout';
import PageSubtitle from './Layout/PageSubtitle';
import PageTitle from './Layout/PageTitle';
import MailToButton from './MailToButton';

/**
 * Renders when error state is set in data import
 * @param {Object} props
 * @param {Object} [props.children] - the error content
 */
export default function Error({ children }) {
  const link = useCommonLinks();
  return (
    <Layout>
      <Box sx={{ textAlign: 'center' }}>
        <StarIcon sx={{ height: 120, width: '120px' }} />
        <PageTitle>
          <Trans>Error</Trans>
        </PageTitle>
        <PageSubtitle>{children}</PageSubtitle>
        <Box sx={{ marginTop: 3 }}>
          <Text variant="default">
            <Button variant="secondary" to={link.root()}>
              <Trans>View imports</Trans>
            </Button>
            <MailToButton
              sx={{ marginLeft: 2 }}
              variant="primary"
              email="support@bottlebooks.me"
              subject="There was an error during import."
            >
              <Trans>Contact support</Trans>
            </MailToButton>
          </Text>
        </Box>
      </Box>
    </Layout>
  );
}
